import { RuleChange, RuleCondition } from '../../../cashflow';
import { getNewTag } from '../getNewTag';
import { CreateRuleToastProps } from './types';

export const getRuleDefaults = ({
    before,
    after,
    field,
}: CreateRuleToastProps) => {
    const defaultConditions: RuleCondition[] = [];
    const defaultChanges: RuleChange[] = [];
    const newTag = getNewTag({ before, after });

    if (before.merchant?.name) {
        defaultConditions.push({
            field: 'merchantName',
            matcher: 'equalToInsensitive',
            value: before.merchant?.name,
        });
    } else {
        defaultConditions.push({
            field: 'statement',
            matcher: 'equalToInsensitive',
            value: before.name,
        });
    }

    if (field === 'merchantId' && after.merchant?.id) {
        defaultChanges.push({
            field,
            value: after.merchant.id,
        });
    } else if (field === 'categoryId') {
        defaultChanges.push({
            field,
            value: after.category.id,
        });
    } else if (field === 'isHidden') {
        defaultChanges.push({
            field,
            value: true,
        });
    } else if (field === 'tagNames' && newTag) {
        defaultChanges.push({
            field,
            value: [newTag.name],
        });
    }

    return { defaultConditions, defaultChanges };
};
